import axios from 'axiosConfig';

export const getAllLoanStatus = () => axios.post("/api/users/loanstatus", {});

export const addNewLoanStatus = (newStatus) => axios.post("/api/users/addloanstatus", newStatus, {});

export const updateLoanStatus = (updatedStatus) => axios.post("/api/users/editloanstatus", updatedStatus, {});

export const deleteLoanStatus = (deleteStatus) => axios.post("/api/users/deleteloanstatus", deleteStatus, {});

export const reactivateLoanStatus = (reactivateStatus) => axios.post("/api/users/reactivateloanstatus", reactivateStatus, {});